import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { IParams } from '../../../../../../shared/types/redirectParams';
import { RedirectParamsDataProps } from './props';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import {
    asyncGetLastCodeParam,
    asyncGetParams,
} from '../../../../../../services/param.service';

export const useRedirectParamsData = ({
    data,
    onChangeData,
    onChangeFormik,
}: RedirectParamsDataProps) => {
    const [newCode, setNewCode] = useState<string>('');
    const [areas, setAreas] = useState<ISelect[]>([]);

    const onSubmit = (data: IParams) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'class',
            data?.class || ParamEnum.PQR_REDIRECTION_PERSON
        );
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('extra2', data?.extra2 || '');
        formik?.setFieldValue('parent', (data?.parent as ISelect)?.id || '');
        formik?.setFieldValue('active', data?.active || false);
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeParam(ParamEnum.PQR_REDIRECTION_PERSON).then(
            (res: any) => {
                setNewCode(res?.items);
            }
        );
    }, [newCode]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_REDIRECTION_AREA).then((items) =>
            setAreas(items)
        );
    }, []);

    return {
        formik,
        areas,
    };
};
